<ng-template appTopbarActions>
  <button mat-raised-button color="accent" style="margin-right: 5px;" (click)="addFormation()"
    [disabled]="readOnly || saving || loading">
    <span class="fx-direction-row fx-align-item-center">
      <mat-icon matTooltip="Ajouter une formation">
        add_box
      </mat-icon>
    </span>
  </button>
</ng-template>

<div [ngClass]="{'formation-list': !isMobile, 'formation-list-mobile': isMobile}">

  <app-loader-overlay *ngIf="loading || saving"></app-loader-overlay>

  <mat-card style="padding: 16px;">
    <table #table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows matSortDirection="asc">

      <ng-container matColumnDef="dateDebut">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="dateDebut">Début</th>
        <td mat-cell *matCellDef="let formation">
          {{formation.dateDebut | date:'dd/MM/yyyy'}} </td>
      </ng-container>

      <ng-container matColumnDef="dateFin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="dateFin">Fin</th>
        <td mat-cell *matCellDef="let formation"> {{formation.dateFin | date:'dd/MM/yyyy'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="programme">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="programme">Programme</th>
        <td mat-cell *matCellDef="let formation"> {{formation.programme}}
        </td>
      </ng-container>

      <ng-container matColumnDef="lieu">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="lieu">Lieu</th>
        <td mat-cell *matCellDef="let formation"> {{formation.lieu }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let formation">
          <button mat-icon-button color="warn" (click)="deleteFormation(formation); $event.stopPropagation()"
            matTooltip="Supprimer" [disabled]="readOnly">
            <mat-icon *ngIf="formation.idFormation !== deleting">delete</mat-icon>
            <mat-progress-spinner *ngIf="formation.idFormation === deleting" mode="indeterminate" strokeWidth="2"
              diameter="24" color="accent" class="icon-loader">
            </mat-progress-spinner>
          </button>
          <button mat-icon-button aria-label="expand row" (click)="toggle(formation); $event.stopPropagation()"
            class="toggle-button" [class.toggle-button-expanded]="isExpanded(formation)">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let formation" [attr.colspan]="displayedColumns.length">
          <div class="formation-detail" [@detailExpand]="formation === expandedFormation ? 'expanded' : 'collapsed'"
            [ngStyle]="{'width': isMobile ? '100%' : '80%'}">

            <div style="margin: 10px 0;" class="fx-direction-col fx-start-stretch">
              <mat-form-field>
                <mat-label>Programme</mat-label>
                <mat-select [(ngModel)]="formation.idProgramme" [disabled]="readOnly">
                  <mat-option *ngFor="let programme of listProgramme" [value]="programme.id">
                    {{programme.label}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="fx-direction-row fx-wrap fx-center-center">
                <mat-form-field class="responsive-field">
                  <mat-label>Du : </mat-label>
                  <input matInput [(ngModel)]="formation.dateDebut" [matDatepicker]="publishFromDatePicker"
                    [max]="formation.dateFin" [disabled]="readOnly" required>
                  <mat-datepicker-toggle matSuffix [for]="publishFromDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #publishFromDatePicker></mat-datepicker>
                  @if(!formation.dateDebut){
                  <mat-error>La date de début est obligatoire.</mat-error>
                  }
                </mat-form-field>

                <mat-form-field class="responsive-field">
                  <mat-label>au : </mat-label>
                  <input matInput [(ngModel)]="formation.dateFin" [matDatepicker]="publishUntilDatePicker"
                    [min]="formation.dateDebut" [disabled]="readOnly" required>
                  <mat-datepicker-toggle matSuffix [for]="publishUntilDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #publishUntilDatePicker></mat-datepicker>
                  @if(formation.dateDebut && formation.dateFin && formation.dateFin < formation.dateDebut){ <mat-error>
                    La date de fin doit être supérieure ou égale à la date de début.
                    </mat-error>

                    }
                    @if(!formation.dateFin){
                    <mat-error>La date de fin est obligatoire.</mat-error>
                    }
                </mat-form-field>
              </div>
              <mat-form-field>
                <mat-label>Etablissement</mat-label>
                <input matInput type="text" [(ngModel)]="formation.lieu" [disabled]="readOnly">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Rue</mat-label>
                <input matInput type="text" [(ngModel)]="formation.rue" [disabled]="readOnly">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Complément d'adresse</mat-label>
                <input matInput type="text" [(ngModel)]="formation.rue2" [disabled]="readOnly">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Complément d'adresse 2</mat-label>
                <input matInput type="text" [(ngModel)]="formation.rue3" [disabled]="readOnly">
              </mat-form-field>
              <div class="fx-direction-row fx-wrap ">
                <mat-form-field style="flex: 1 1 30%; max-width: 30%;">
                  <mat-label>Code postal</mat-label>
                  <input matInput type="text" [(ngModel)]="formation.codePostal" [disabled]="readOnly">
                </mat-form-field>
                <mat-form-field style="flex: 1 1 70%; max-width: 70%;">
                  <mat-label>Ville</mat-label>
                  <input matInput type="text" [(ngModel)]="formation.ville" [disabled]="readOnly">
                </mat-form-field>
              </div>


              <div class="label-compte-rendu fx-direction-row fx-align-item-center"> <mat-icon
                  color="primary">chevron_right</mat-icon> Compte rendu de la formation </div>
              <text-editor [(ngModel)]="formation.commentaire" [toolbar]="editorToolbar" allowImages="false"
                [disabled]="readOnly"></text-editor>
            </div>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="formation-row"
        [class.expanded-row]="expandedFormation === row"
        (click)="expandedFormation = expandedFormation === row ? null : row"
        [@highlightRowsAnimation]="row.highlightRowsAnimation" [@rowEnterLeave]="row.rowEnterLeaveAnimation">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[20, 50, 100, 200]" showFirstLastButtons></mat-paginator>
  </mat-card>

  <div class="save-content fx-direction-row fx-end-center">

    <button color="primary" mat-raised-button (click)="save()"
      [disabled]="readOnly || loading || saving || hasInvalidDates()">

      <mat-icon [hidden]="saving" matTooltip="Enregistrer">save</mat-icon>
      <div class="fx-direction-row fx-align-item-center fx-gap-5">
        @if (saving) {
        <mat-progress-spinner mode="indeterminate" strokeWidth="2" diameter="18" color="accent"></mat-progress-spinner>
        }
        <span>Enregistrer</span>
      </div>

    </button>

  </div>
</div>